import { create } from 'vue-modal-dialogs';

import modalVerifyParentCode from '@/components/purchase/purchase-approval';

const verifyParentCode = create(modalVerifyParentCode),
	dialogHelper = {
		install(vue) {
			vue.prototype.$dialog = {
				verifyParentCode,
			};
		},
	};

export default dialogHelper;
